import { AlertFilterTypes } from "./hooks/useAlerts";

const AlertQueryKeys = {
  global: ["alerts"] as const,
  alerts: (filter: AlertFilterTypes, followMention?: Boolean) =>
    [...AlertQueryKeys.global, filter, !!followMention] as const,
  categories: () => [...AlertQueryKeys.global, "categories"] as const,
  accounts: (id: string) => [...AlertQueryKeys.global, id, "accounts"] as const,
  alert: (id: string) => [...AlertQueryKeys.global, id] as const,
  count: () => [...AlertQueryKeys.global, "count"] as const,
};

export { AlertQueryKeys };
